var escapeChars = {
  "\xA2": "cent",
  "\xA3": "pound",
  "\xA5": "yen",
  "\u20AC": "euro",
  "\xA9": "copy",
  "\xAE": "reg",
  "<": "lt",
  ">": "gt",
  '"': "quot",
  "&": "amp",
  "'": "#39"
};
module.exports = escapeChars;
